import classNames from "classnames";
import React, { useState } from "react";
import ReactTooltip from "react-tooltip";

export default function ({ text, className }) {
  return (
    <div
      className={classNames("form-item-info form-item-info-mobile", {
        [className]: !!className,
      })}
    >
      <ReactTooltip />
      <div
        className="form-item__info-btn form-item__info-btn-mobile"
        data-tip={text}
      >
        i
      </div>
      <p className="form-item__info-block"></p>
    </div>
  );
}
